import * as Yup from 'yup';
import { messages } from 'app/config/constants';
import { SUBJECT_TYPE_ENUM } from 'app/shared/enumeration/enums';

export const casesFilterValidationSchema = (anyApplicantFieldIsNotEmpty ) => Yup.object({
  webId: Yup.string().min(3, 'Potrebno je unijeti minimalno 3 znaka.'),
  classification: Yup.string().min(6, 'Potrebno je unijeti minimalno 6 znaka.'),
  applicantOib: Yup.string()
    .matches(/^\d+$/, messages.ONLY_DIGITS)
    .min(11, messages.OIB_MIN_MAX_LENGTH)
    .max(11, messages.OIB_MIN_MAX_LENGTH)
    .when('applicantSubjectType', (keys, schema) =>
      keys[0] &&
      keys[0][0] &&
      [SUBJECT_TYPE_ENUM.PRAVNA_OSOBA, SUBJECT_TYPE_ENUM.FIZICKA_OSOBA].includes(keys[0][0].id) &&
      !anyApplicantFieldIsNotEmpty()
        ? schema.required(' ')
        : schema.notRequired(),
    ),
  applicantMb: Yup.string()
    .matches(/^\d+$/, messages.ONLY_DIGITS)
    .min(2, 'Potrebno je unijeti minimalno 2 znaka.')
    .max(11, 'MB mora imati maksimalno 11 znakova.')
    .when('applicantSubjectType', (keys, schema) =>
      keys[0] &&
      keys[0][0] &&
      [SUBJECT_TYPE_ENUM.OBRT, SUBJECT_TYPE_ENUM.SLOBODNA_DJELATNOST, SUBJECT_TYPE_ENUM.OPG].includes(keys[0][0].id) &&
      !anyApplicantFieldIsNotEmpty()
        ? schema.required(' ')
        : schema.notRequired(),
    ),
  applicantFirstName: Yup.string()
    .min(2, 'Potrebno je unijeti minimalno 2 znaka.')
    .when('applicantSubjectType', (keys, schema) =>
      keys[0] && keys[0][0] && keys[0][0].id === SUBJECT_TYPE_ENUM.FIZICKA_OSOBA && !anyApplicantFieldIsNotEmpty()
        ? schema.required(' ')
        : schema.notRequired(),
    ),
  applicantLastName: Yup.string()
    .min(2, 'Potrebno je unijeti minimalno 2 znaka.')
    .when('applicantSubjectType', (keys, schema) =>
      keys[0] && keys[0][0] && keys[0][0].id === SUBJECT_TYPE_ENUM.FIZICKA_OSOBA && !anyApplicantFieldIsNotEmpty() ? schema.required(' ') : schema.notRequired(),
    ),
  applicantCompanyName: Yup.string()
    .min(2, 'Potrebno je unijeti minimalno 2 znaka.')
    .when('applicantSubjectType', (keys, schema) =>
      keys[0] && keys[0][0] && keys[0][0].id !== SUBJECT_TYPE_ENUM.FIZICKA_OSOBA && !anyApplicantFieldIsNotEmpty() ? schema.required(' ') : schema.notRequired(),
    ),
});
